export default "__VITE_ASSET__CwJ_HrB2__"